import { Directive, OnInit } from '@angular/core';
import { dictionaryBooking } from 'src/models/languageBooking';
import { LookAndFeelWebView } from 'src/models/LookAndFeelWebView';
import { PublicSiteConfig } from 'src/services/publicSiteConfig.service';
import { ViewType } from '../enums/viewType.enum';

@Directive()
export abstract class PublicSiteConfigBaseComponent
  implements OnInit {

  protected CurrentBrand!: LookAndFeelWebView;
  protected indexbrand!: number;
  protected indexCountry!: number;
  protected recievedBrandData: any = history.state.brand as {}
  protected recievedCountryData: any = history.state.country as {}
  protected languages: dictionaryBooking[] = []
  private webviewType: ViewType;

  protected constructor(
    protected publicSiteConfig: PublicSiteConfig,
    protected _webviewType: ViewType = ViewType.Standalone
  ) {
    this.languages = this.publicSiteConfig.language;
    this.indexbrand = Number(this.recievedBrandData);
    this.indexCountry = Number(this.recievedCountryData);
    this.webviewType = _webviewType;
  }

  async ngOnInit(): Promise<void> {
    await this.loadConfig();
    this.afterConfigLoaded();
  }

  protected async loadConfig(): Promise<void> {
    if (!this.indexbrand || !this.indexCountry) {
      return;
    }
    
    this.CurrentBrand = await this.publicSiteConfig.getPublicSiteConfig(
      this.indexbrand,
      this.indexCountry,
      this.webviewType
    );
  }

  protected abstract afterConfigLoaded(): void;
}